import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import axios from "axios";
import { ROLL_CALL_API_BASE_URL } from "../../Pereco/RollCall/RollCallConfig/RollCallConfig";
import CommonFooter from "../../../core/common/footer/commonFooter";

const Signin = () => {
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [Username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setloading] = useState(false);
  const navigate = useNavigate();
  const route = all_routes;
  const PayrollSuperId = "10051";

  const togglePasswordVisibility = () => {
    setPasswordVisible((prev) => !prev);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setloading(true);

    try {
      const response = await axios.post(
        `${ROLL_CALL_API_BASE_URL}portal/user/login`,
        {
          username: Username,
          password: password,
        }
      );

      console.log("Login Response:", response);

      const { ResultData } = response.data;
      const { Token, IsAdmin, SuperId } = ResultData;

      if (Token && IsAdmin && SuperId) {
        sessionStorage.setItem("authToken", Token);
        sessionStorage.setItem("userData", JSON.stringify(ResultData));
        sessionStorage.setItem("superId", SuperId);
        sessionStorage.setItem("PayrollSuperId", PayrollSuperId);
        navigate(route.rollcalldashboard);
      } else {
        alert("Access denied. Only Admins can access the dashboard.");
      }
    } catch (error) {
      alert("Login failed. Please check your credentials.");
      console.error("Login error:", error);
    } finally {
      setloading(false);
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    if (token) {
      navigate(route.rollcalldashboard, { replace: true });
    }
  }, []);

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className=" login-wrapper container">
          <div className="row">
            <div className="col-lg-5 d-flex justify-content-end p-0">
              <div className="login-content user-login">
                <form onSubmit={handleLogin}>
                  <div className="card">
                    <div className="card-header border-0">
                      <div className="login-logo">
                        <ImageWithBasePath
                          src="assets/img/logo.png"
                          alt="img"
                          className="mb-0"
                        />
                        <Link className="login-logo logo-white">
                          <ImageWithBasePath
                            src="assets/img/logo-white.png"
                            alt="Img"
                          />
                        </Link>
                      </div>
                    </div>
                    <div className="card-body px-5 pb-3">
                      <div className="login-userheading">
                        <h3>Sign In</h3>
                        <h4 className="fs-16">
                          Access the Pereco RollCall panel using your UserName
                          and PassWord.
                        </h4>
                      </div>
                      <div className="mb-3">
                        <label className="form-label">
                          UserName <span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control border-end-0"
                            value={Username}
                            onChange={(e) => setUserName(e.target.value)}
                            // required
                          />
                          <span className="input-group-text border-start-0">
                            <i className="ti ti-mail" />
                          </span>
                        </div>
                      </div>
                      <div className="mb-3">
                        <label className="form-label">
                          Password <span className="text-danger">*</span>
                        </label>
                        <div className="pass-group">
                          <input
                            type={isPasswordVisible ? "text" : "password"}
                            className="pass-input form-control"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                          />
                          <span
                            className={`ti toggle-password ${
                              isPasswordVisible ? "ti-eye" : "ti-eye-off"
                            }`}
                            style={{ color: "#1c1a1a" }}
                            onClick={togglePasswordVisibility}
                          ></span>
                        </div>
                      </div>

                    <div className="form-login">
                        <button
                          type="submit"
                          className="btn btn-primary w-100"
                          disabled={loading}
                        >
                          {loading ? (
                            <div className="spinner-border" role="status"></div>
                          ) : (
                            "Sign In"
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-lg-7 d-flex justify-content-start align-items-center">
              <div className="">
                <div
                  id="carouselExampleFade"
                  className="carousel slide carousel-fade"
                  data-bs-ride="carousel"
                  data-bs-interval="2000"
                >
                  <div className="carousel-inner">
                    <div className="carousel-item active">
                      <ImageWithBasePath
                        className="d-block img-flui"
                        src="assets/img/slider-1.png"
                        alt="First slide"
                        height={600}
                      />
                    </div>
                    <div className="carousel-item">
                      <ImageWithBasePath
                        className="d-block img-flui"
                        src="assets/img/slider-2.png"
                        alt="Second slide"
                        height={600}
                      />
                    </div>
                    <div className="carousel-item">
                      <ImageWithBasePath
                        className="d-block img-flui"
                        src="assets/img/slider-3.png"
                        alt="Third slide"
                        height={600}
                      />
                    </div>
                    <div className="carousel-item">
                      <ImageWithBasePath
                        className="d-block img-flui"
                        src="assets/img/slider-4.png"
                        alt="Fourth slide"
                        height={600}
                      />
                    </div>
                  </div>
                  <a
                    className="carousel-control-prev"
                    href="#carouselExampleFade"
                    role="button"
                    data-bs-slide="prev"
                  >
                    <span
                      className="carousel-control-prev-icon"
                      aria-hidden="true"
                    />
                    <span className="visually-hidden">Previous</span>
                  </a>
                  <a
                    className="carousel-control-next"
                    href="#carouselExampleFade"
                    role="button"
                    data-bs-slide="next"
                  >
                    <span
                      className="carousel-control-next-icon"
                      aria-hidden="true"
                    />
                    <span className="visually-hidden">Next</span>
                  </a>
                </div>
              </div>
            </div>
            <CommonFooter></CommonFooter>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signin;
